import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import { useEffect, useRef, useState } from "react";

export function AppCodesJustificationInput({ value, defaultValue, updateInfoPromeCode }) {
  const inputRef = useRef(null);
  const [justification, setJustification] = useState(value ?? "");
  const [backUpJustification, setBackUpJustification] = useState(value ?? "");
  const [ableToUpdate, setAbleToUpdate] = useState(false);

  const updateJustification = async () => {
    setAbleToUpdate(false);
    if (justification === "" || justification === backUpJustification) {
      setJustification(backUpJustification);
    } else {
      setBackUpJustification(justification);
      updateInfoPromeCode(justification);
    }
  };

  const handleOnEnterJustification = (e) => {
    if (e.key === "Enter") updateJustification();
  };

  useEffect(() => {
    if (ableToUpdate) inputRef.current.focus();
  }, [ableToUpdate, value]);

  return (
    <VuiBox>
      <VuiBox
        component="input"
        type="text"
        ref={inputRef}
        onChange={(e) => setJustification(e.target.value)}
        value={justification}
        placeholder="Escribe tu justificacion"
        sx={{
          fontSize: "12px",
          letterSpacing: "0.5px",
          lineHeight: "15.6px",
          fontWeight: "500",
          color: "#FFF",
          border: "none",
          outline: "none",
          display: ableToUpdate ? "flex" : "none",
          width: "100%",
          width: "9rem",
        }}
        onBlur={updateJustification}
        onKeyDown={handleOnEnterJustification}
        autoFocus
      />
      <VuiBox
        color="white"
        sx={{
          fontSize: "12px",
          letterSpacing: "0.5px",
          lineHeight: "15.6px",
          fontWeight: "500",
          display: "flex",
          whiteSpace: "nowrap",
          width: "9rem",
          display: !ableToUpdate ? "flex" : "none",
        }}
      >
        <VuiTypography
          sx={{
            fontSize: "12px",
            letterSpacing: "0.5px",
            lineHeight: "15.6px",
            fontWeight: "500",
            display: "flex",
            whiteSpace: "nowrap",
            color: "#FFF",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "8.5rem",
          }}
        >
          {!value ? defaultValue : value}
        </VuiTypography>

        <ModeOutlinedIcon
          sx={{
            color: "#A0AEC0",
            marginLeft: "10px",
            cursor: "pointer",
            "&:hover": { color: "#FFF" },
          }}
          onClick={() => {
            setAbleToUpdate(!ableToUpdate);
            if (!ableToUpdate) {
              setJustification(value ?? "");
              setBackUpJustification(value ?? "");
            }
          }}
        />
      </VuiBox>
    </VuiBox>
  );
}
